export default "__VITE_ASSET__BUN_0hlt__"